import lottie from 'lottie-web'
import 'events-polyfill/src/constructors/Event'

import loaderpath from '../../anims/loader.json'

export default class Loader {
    constructor() {
        this.init()
    }

    init() {
        this.element = document.querySelector('.global__loader')

        this.animation = lottie.loadAnimation({
            path: loaderpath,
            container: this.element,
            autoplay: true,
            loop: true,
            rendererSettings: {
                preserveAspectRatio: 'xMinYMid slice',
            },
        })

        this.initEvents()
    }

    initEvents() {
        document.addEventListener('DOMContentLoaded', () => {
            this.end()
        })

        this.endEvent = new Event('loaderFinished')
    }

    end() {
        this.element.classList.add('hidden')
        document.body.dispatchEvent(this.endEvent)

        setTimeout(() => {
            this.animation.stop()
            this.element.remove()
        }, 1000)
    }
}
